var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "edit-pen@1x-a",
          d:
            "M19.9999869,8.1917098 C20.0012029,7.97908348 19.917723,7.77471637 19.7679743,7.62375271 L16.3759855,4.23200896 C16.2250109,4.08227106 16.0206291,3.99879717 15.8079874,4.0000131 C15.5953457,3.99879717 15.3909638,4.08227106 15.2399893,4.23200896 L12.9759968,6.49583793 L12.9759968,6.49583793 L4.23202572,15.2391774 C4.08227701,15.390141 3.99879709,15.5945081 4.0000131,15.8071345 L4.0000131,19.1988782 C4.0000131,19.6406726 4.3581975,19.9988178 4.80002384,19.9988178 L8.19201261,19.9988178 C8.41839693,20.0111307 8.63937477,19.9268163 8.8000106,19.7668353 L17.4959818,11.0234959 L17.4959818,11.0234959 L19.7679743,8.79966387 C19.8409955,8.72213453 19.9004881,8.63290213 19.9439737,8.53568382 C19.9516815,8.47192071 19.9516815,8.40746143 19.9439737,8.34369832 C19.9477164,8.3064616 19.9477164,8.2689435 19.9439737,8.23170678 L19.9999869,8.1917098 Z M7.8640137,18.3989386 L5.60002119,18.3989386 L5.60002119,16.1351097 L13.5439949,8.1917098 L15.8079874,10.4555388 L7.8640137,18.3989386 Z M16.9359837,9.32762398 L14.6719912,7.06379502 L15.8079874,5.93588023 L18.0639799,8.1917098 L16.9359837,9.32762398 Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "fill-rule": "nonzero",
          "xlink:href": "#edit-pen@1x-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }